import fetchCompanyInfo from "./fetchCompanyInfo.api";

const companyApi = {
    fetchCompanyInfo
};

export default companyApi;
